<template>
	<div class="section">
		<div class="profile_page">
			<b-overlay :show="isLoading">
				<div v-if="success_2" class="success">
					<h2>Пароль изменен</h2>
					<b-button variant="primary" :href="cas_url" onclick="this.blur();" style="float: right;">Войти в систему</b-button>
				</div>
				<div v-else-if="success_1">
					<h1 class="text-xs-center">Восстановление</h1>
					<BasePassword :user="user" :passwordText="'Новый пароль:'" ref="basePassword"/>
					<div v-if="error" class="error">
						<h5>{{ error }}</h5>
					</div>
					<div v-if="errors.length > 0">
						<div class="error" v-for="(error_sub, index) in errors" :key="index">{{ error_sub }}</div>
					</div>
					<b-button variant="primary" v-on:click="save" onclick="this.blur();" style="float: right;">Восстановить</b-button>
				</div>
				<div v-else>
					<div v-if="error" class="error">
						<h5>{{ error }}</h5>
					</div>
					<div v-if="errors.length > 0">
						<div class="error" v-for="(error_sub, index) in errors" :key="index">{{ error_sub }}</div>
					</div>
				</div>
			</b-overlay>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { RESET_PASSWORD, CHECH_PASSWORD_TOKEN } from '@/store/actions.type'
import BasePassword from '@/components/views/Manager/Shared/BasePassword'

export default {
	name: 'ProfileResetPassword',
	props: ['uid', 'token'],
	data () {
		return {
			user : {
				password: '',
				password_confirm: ''
			},
			success_1: false,
			success_2: false,
			error: '',
			visited: [],
			cas_url: process.env.CAS_URL + "/login?locale=ru&service=" + process.env.SERVICE_URL
		}
	},
	created () {
		this.fetchData()
	},
	watch: {
		'$route': 'fetchData'
	},
	computed: {
		...mapGetters({
			isLoading: 'resetPasswordIsLoading',
			errors: 'resetPasswordErrors'
		})
	},
	components: {
		BasePassword
	},
	methods: {
		fetchData () {
			if (this.uid && this.uid.length > 0 && this.token && this.token.length > 0) {
				this.$store.dispatch(CHECH_PASSWORD_TOKEN, { uid: this.uid,	token: this.token })
				.then((data) => {
					this.success_1 = data === true ? true : false
					this.error = data === true ? '' : "Неверно указаны данные"
				})
			} else {
				this.error = "Неверно указаны данные"
			}
		},
		save () {
			this.$refs.basePassword.$v.user.$touch()
			if (this.$refs.basePassword.$v.user.$anyError) {
				return
			}

			this.$store.dispatch(RESET_PASSWORD, {
				uid: this.uid,
				token: this.token,
				password: this.user.password,
				confirmPassword: this.user.password_confirm
			})
			.then((data) => {
				this.success_2 = data === true ? true : false
				this.error = data === true ? null : "Не удалось восстановить пароль"
			})
		},
		validatePassword(name) {
			const { $dirty, $error } = this.$v[name]
			return $dirty ? !$error : null
		}
	}
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/views/Profile/ResetPassword.vue